'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Samp = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _Code = require('./Code');

var _Code2 = _interopRequireDefault(_Code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Samp = exports.Samp = (0, _components2.default)({
  is: 'samp',
  extend: _Code2.default
});

Samp.displayName = 'Samp';

exports.default = Samp;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Samp.js
// module id = 3992
// module chunks = 16